import { createGraphqlFetcher } from '@apis/createFetcher';

const apis = {
    getPageList: {
        name: 'queryLpBatchReport',
        query: `query queryLpBatchReport ($where: LpPageBatchWhereUniqueInput!) {
            queryLpBatchReport(where:$where){
                id
                assetType
                assetName
                refId
                profileId
                parentId
                path
                createBy
                data {
                    visitors
                    conversion {
                        conversionId
                        conversionName
                        value
                        rate
                    }
                    pageViews
                    avgVisitDuration
                    bounce
                    heatmap {
                        pid
                        startTimeString
                        endTimeString
                        lastDaysPv
                    }
                }
                status
                protocol
                domain
                url
                createTime
                updateTime
                deviceType
                versions {
                    id
                    mobileThumbnail
                    pcThumbnail
                }
            }
        }`
    },
    createAsset: {
        name: 'createAsset',
        query: `mutation createAsset($input: AssetInput){
            createAsset(input: $input){
                id
                createTime
                modifyTime
                deleteTime
                assetType
                refId
                profileId
                parentId
                path
            }
        }`
    },
    deleteAssets: {
        name: 'deleteAssets',
        query: `mutation deleteAssets($input:AssetOperateInput){
                deleteAssets(input:$input)
            }`
    },
    deletePage: {
        name: 'deletePage',
        query: `mutation deletePage($id: ID!) {
            deletePage(id: $id)
        }

        `
    },
    updateAsset: {
        name: 'updateAsset',
        query: `mutation updateAsset($input:AssetInput){
            updateAsset(input:$input){
                id
                assetName
            }
        }`
    },
    moveAssets: {
        name: 'moveAssets',
        query: `mutation moveAssets($input:AssetOperateInput) {
            moveAssets(input:$input)
        }`
    },
    copyAssets: {
        name: 'copyAssets',
        query: `mutation copyAssets($input:AssetOperateInput){
            copyAssets(input:$input)
        }`
    },
    copyPage: {
        name: 'copyPage',
        query: `
            mutation copyPage($id: ID!, $newParentId: ID) {
                copyPage(id: $id, newParentId:$newParentId)
            }

        `
    },
    getAssetsTree: {
        name: 'getFolderTree',
        query: `query getFolderTree($folderId:String){
                getFolderTree(folderId:$folderId)
            }`
    },
    createPage: {
        name: 'createPage',
        query: `
            mutation createPage($input: CreatePageInput) {
                createPage(input: $input) {
                    id
                }
            }
        `
    },
    getPage: {
        name: 'getPage',
        query: `
            query getPage($id: ID){
                getPage(id: $id) {
                    id
                    pageName
                    createTime
                    updateTime
                    publishTime
                    pauseTime
                    profileId
                    title
                    url
                    domain
                    domainProtocol
                    deviceType
                    status
                    metadata
                    versions {
                        id
                        mobileContent
                        pcContent
                        mobileThumbnail
                        pcThumbnail
                    }
                    font
                }
            }

        `
    },
    savePage: {
        name: 'savePage',
        query: `
            mutation savePage($input: SavePageInput) {
                savePage(input: $input) {
                    id
                    pageName
                    title
                    url
                    domain
                    deviceType
                    versions {
                        id
                        mobileContent
                        pcContent
                        mobileThumbnail
                        pcThumbnail
                    }
                    status
                    metadata
                 }
            }
        `
    },
    publishPage: {
        name: 'publishPage',
        query: `
            mutation publishPage($input: PublishPageInput) {
                publishPage(input: $input) {
                    pageId
                }
            }
        `
    },
    unpublishPage: {
        name: 'unpublishPage',
        query: `
            mutation unpublishPage($input: UnpublishPageInput) {
                unpublishPage(input: $input)
            }
        `
    },
    getLpDataReport: {
        name: 'queryLpDataReport',
        query: `
            query queryLpDataReport($where: LpPageDataWhereUniqueInput!) {
                queryLpDataReport(where: $where) {
                    visitors
                    conversion {
                        conversionId
                        conversionName
                        value
                        rate
                    }
                    pageViews
                    avgVisitDuration
                    bounce
                    heatmap {
                        pid
                        startTimeString
                        endTimeString
                        lastDaysPv
                    }
                }
            }
        `
    },
    getLpDataReportCurve: {
        name: 'queryLpDataReportCurve',
        query: `
            query queryLpDataReportCurve($where: LpPageCurveWhereUniqueInput!) {
                queryLpDataReportCurve(where: $where){
                    time
                    value
                    rate
                }
            }

        `
    },
    getLpDataBlockReport: {
        name: 'queryLpDataBlockReport',
        query: `
            query queryLpDataBlockReport($where: LpPageDataWhereUniqueInput!) {
                queryLpDataBlockReport(where: $where) {
                    total {
                        blockName
                        impressions
                        impressionsRate
                        exitRate
                        clicks
                        clickRate
                        stayDuration
                        conversions {
                            conversionId
                            conversionName
                            value
                            rate
                        }
                    }
                    block {
                        blockName
                        impressions
                        impressionsRate
                        exitRate
                        clicks
                        clickRate
                        stayDuration
                        conversions {
                            conversionId
                            conversionName
                            value
                            rate
                        }
                    }
                }
            }
        `
    },
    queryAllFormByPageId: {
        name: 'queryAllFormByPageId',
        query: `
            query queryAllFormByPageId($pageId: String!) {
                queryAllFormByPageId(pageId: $pageId) {
                    formId
                    formName
                }
            }
        `
    },
    queryFormDataByPageId: {
        name: 'queryFormDataByPageId',
        query: `
            query queryFormDataByPageId($input: LpQueryFormDataArgsInput!) {
                queryFormDataByPageId(input: $input) {
                    id
                    profileId
                    pageId
                    pageVersionId
                    formId
                    formName
                    formValues
                    createTime
                     }
            }
        `
    },
    getAssetList: {
        name: 'getAssetList',
        query: `
            query getAssetList($ids: [String!]!){
                getAssetList(ids:$ids){
                    id
                    createTime
                    modifyTime
                    deleteTime
                    assetType
                    assetName
                    refId
                    profileId
                    parentId
                    path
                }
            }
        `
    },
    getAssetsCount: {
        name: 'getProfileRootPageCount',
        query: `
            query getProfileRootPageCount{
                getProfileRootPageCount
            }
        `
    },
    getAssetByRefId: {
        name: 'getAssetByRefId',
        query: `
            query getAssetByRefId($id: ID!) {
                getAssetByRefId(id: $id) {
                    id
                    path
                }
            }
        `
    },
    uploadImageByUrl: {
        name: 'otherServiceApi',
        query: `query otherServiceApi($where: ServiceApiInput!){
            otherServiceApi(where:$where)
        }`
    }
};

export default createGraphqlFetcher(apis);
